<div
  class="notification"
  *ngIf="
    topPriorityComplianceNotification$ | async as complianceNotificationType
  "
>
  <ng-container [ngSwitch]="complianceNotificationType">
    <cp-compliance-expired-notification
      *ngSwitchCase="complianceNotificationTypes.expired"
    ></cp-compliance-expired-notification>
    <cp-compliance-due-to-expire-notification
      *ngSwitchCase="complianceNotificationTypes.dueToExpire"
    ></cp-compliance-due-to-expire-notification>
    <cp-compliance-lapsed-notification
      *ngSwitchCase="complianceNotificationTypes.lapsed"
    ></cp-compliance-lapsed-notification>
  </ng-container>
</div>
<div
  class="notification"
  *ngIf="topPriorityTrainingNotification$ | async as trainingNotificationType"
>
  <ng-container [ngSwitch]="trainingNotificationType">
    <cp-training-cancelled-notification
      *ngSwitchCase="trainingNotificationTypes.trainingCancelled"
    ></cp-training-cancelled-notification>
  </ng-container>
</div>
